import { render, staticRenderFns } from "./system-list.vue?vue&type=template&id=71f5c00b&"
import script from "./system-list.vue?vue&type=script&lang=js&"
export * from "./system-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports